module.exports = __webpack_public_path__ + "img/mic-clinic-phone.92120d1d.svg";